class Search {
	constructor(el) {
		this.el = el
		this.typeAhead = this.el.querySelector('[data-role="js--type-ahead"]')
		const searchTrigger = document.querySelector('[data-target="#site-header-search"]')
		this.searchInput = this.el.querySelector('[data-role="js--search-input"]')
		searchTrigger && searchTrigger.addEventListener('click', () => {
			setTimeout(() => {
				this.searchInput.focus();
			}, 200);
		})
		this.searchInput && this.searchInput.addEventListener('keyup', this._handleSearchInput.bind(this))
	}
	_handleSearchInput(event) {
		this.typeAhead.setAttribute('style','display:block;')
		setTimeout(function() {
			this.typeAhead.classList.add('is-active')
		}.bind(this), 1000);
	}
}

export default Search
